var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"qs-button qs-text__upper",class:{'qs-button__fullwidth' : _vm.fullWidth, disabled: _vm.disabled},on:{"click":_vm.emitClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }